import { Stack } from '@mui/material'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import shared from '@/components/Settings/settingsShared.module.scss'
import { THEME_OPTIONS } from './GeneralSettingsContent/generalSettingsConstants.js'
import { GeneralSettingsProfileSection } from './GeneralSettingsContent/GeneralSettingsProfileSection.jsx'
import { GeneralSettingsSelectRowSection } from './GeneralSettingsContent/GeneralSettingsSelectRowSection.jsx'
import { GeneralSettingsSection } from './GeneralSettingsContent/GeneralSettingsSection.jsx'
import { ActiveSessionsTable } from './GeneralSettingsContent/ActiveSessionsTable.jsx'
import { GeneralSettingsMoreSection } from './GeneralSettingsContent/GeneralSettingsMoreSection.jsx'
import { useGeneralSettingsState } from './GeneralSettingsContent/useGeneralSettingsState.js'

export default function GeneralSettingsContent() {
  const s = useGeneralSettingsState()
  const paperSingle = settingsRowPaperClassName({ groupPosition: 'single' })
  const paperFirst = settingsRowPaperClassName({ groupPosition: 'first' })
  const paperLast = settingsRowPaperClassName({ groupPosition: 'last' })

  return (
    <Stack spacing={3} className={shared.briefingsRoot}>
      <GeneralSettingsSelectRowSection
        title="Appearance"
        introKey="general-appearance"
        paperSingle={paperSingle}
        rowTitle="Theme"
        rowDescription="Choose light, dark, or match your device appearance."
        ariaLabel="Theme"
        value={s.theme}
        options={THEME_OPTIONS}
        onChange={s.setTheme}
      />
      <GeneralSettingsProfileSection paperSingle={paperSingle} email={s.email} firstName={s.firstName} lastName={s.lastName} onFirstNameChange={s.setFirstName} onLastNameChange={s.setLastName} />
      <GeneralSettingsSection title="Active Sessions" introKey="general-sessions">
        <ActiveSessionsTable />
      </GeneralSettingsSection>
      <GeneralSettingsMoreSection paperFirst={paperFirst} paperLast={paperLast} />
    </Stack>
  )
}
